define('models/config/Organization',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Organization = ObservableModel.extend({
        defaults: {
            domain: '',
            defaultSiteId: undefined
        }
    }, function () {

        var self = this;

        self.domain.extend({ required: true });
        ko.validation.group(self);

        self.unwrap = function () {
            return ObservableModel.unwrap(self, [
                'unwrap',
                'errors',
                'isAnyMessageShown',
                'isValid'
            ]);
        };

    });

    return Organization;

});
